import type { ComposerStarter } from '@/types/composer';
import { getResolvedSuggestionPillClassName } from '@/components/chat/chat-message-styles';
import { cn } from '@/lib/utils';

interface ComposerStartersProps {
  starters: ComposerStarter[];
  onPickStarter: (message: string) => void;
  className?: string;
}

export function ComposerStarters({
  starters,
  onPickStarter,
  className,
}: ComposerStartersProps) {
  if (!starters.length) return null;

  return (
    <div
      className={cn(
        'flex w-full min-w-0 flex-wrap items-center justify-center gap-2 px-4',
        className
      )}
      role="group"
      aria-label="Suggested prompts"
    >
      {starters.map((starter) => (
        <button
          key={starter.message}
          type="button"
          className={getResolvedSuggestionPillClassName()}
          title={starter.message}
          onClick={() => onPickStarter(starter.message)}
        >
          <span className="truncate">{starter.label}</span>
        </button>
      ))}
    </div>
  );
}
